export const BEM_BLOCK_NAME: string = 'giving_history';
export const GIVING_SADDLEBACK_EMAIL: string = 'giving@saddleback.com';
export const GIVING_SADDLEBACK_PHONE_NUMBER: string = '(949) 609-8138';
export const GIVING_SADDLEBACK_PHONE_NUMBER_TEL_LINK: string = 'tel:+19496098138';
export const CURRENT_YEAR: number = new Date().getFullYear();
export const NUM_PRIOR_YEARS_STATEMENTS: number = 7;
